import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DASHBOARD_ROUTES } from './dashboard.routes';
import { DashboardComponent } from './dashboard.component';

const routes: Routes = [
  {
    path: DASHBOARD_ROUTES.ROOT,
    component: DashboardComponent,
    children: [
      {
        path: DASHBOARD_ROUTES.STUDIES,
        loadChildren: () => import('./studies/studies.module').then((s) => s.StudiesModule),
        data: { breadcrumb: 'STUDIES' },
      },
      {
        path: DASHBOARD_ROUTES.SETTINGS,
        loadChildren: () => import('./settings/settings.module').then((s) => s.SettingsModule),
        data: { breadcrumb: 'SETTINGS' },
      },
      {
        path: DASHBOARD_ROUTES.ROOT,
        redirectTo: DASHBOARD_ROUTES.STUDIES,
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardRoutingModule {}
